var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "left" }, [
    _c("div", { staticClass: "el-card__header clearfix" }, [
      _vm._v("物资分类"),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "tree-box-con" }, [
      _c(
        "div",
        { directives: [{ name: "height", rawName: "v-height" }] },
        [
          _c(
            "el-scrollbar",
            { staticStyle: { height: "100%" } },
            [
              _c("el-tree", {
                ref: "tree",
                attrs: {
                  data: _vm.parentTree,
                  props: _vm.defaultProps,
                  "highlight-current": true,
                  "filter-node-method": _vm.filterNode,
                  "default-expand-all": true,
                  "expand-on-click-node": false,
                  "icon-class": "el-icon-arrow-right",
                  "node-key": "value",
                },
                on: { "node-click": _vm.handleClick },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var node = ref.node
                      return _c("div", { staticClass: "custom-tree-node" }, [
                        _c("div", { staticClass: "flex-box" }, [
                          _c("span", { staticClass: "over-text" }, [
                            _vm._v(_vm._s(node.label)),
                          ]),
                        ]),
                      ])
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }